import { performRequestSecond } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';

export const getUserProfileDetails = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getUserProfile}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const updateUserProfileDetails = (data, excludeFromLoading = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.updateUserProfile}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&update_preference=${
    data?.update_preference || false
  }`;
  delete data?.update_preference;
  return performRequestSecond(apiEndPoints.methodType.PATCH, url, data, '', true, excludeFromLoading);
};

export const getNotificationPreferences = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getNotificationPreferences}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const updateNotificationPreferences = (data, excludeFromLoading = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.updateNotificationPreferences}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data, '', true, excludeFromLoading);
};
